import React, { useEffect, useState, Component } from "react"
import ReactSlidingSidePanel from "../../components/bottom-slider/ReactSlidingSidePanel"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import Footer from "../footer/Footer"
import "../../css/AboutUs.css"
import Header from "../navbar/Header"
// import { jsx, css } from "@emotion/react"
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt"
import ClinicalAdvisoryCard from "./ClinicalAdvisoryCard"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorScreen } from "../error/ErrorScreen"
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input"
import Input from "react-phone-number-input/input"
import axios from "axios"
import { baseUrl } from "../../lib/constants"
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel"
import "pure-react-carousel/dist/react-carousel.es.css"
import SlidingPane from "react-sliding-pane"
import "react-sliding-pane/dist/react-sliding-pane.css"

var store = require("store")

const doctors = [
  {
    key: "DrSagar",
    name: "Dr. Sagar Parikh",
    accreditations: "MD, FRCP(C)",
    photo: "doctors/doctor1.svg",
    bio: "In March 2015, Dr. Sagar Parikh was appointed as the John F. Greden Professor of Depression and Clinical Neuroscience, and Professor of Psychiatry, at the University of Michigan, Ann Arbor, where he was also designated Associate Director of the Michigan Comprehensive Depression Center. Dr. Parikh is also Professor of Psychiatry at the University of Toronto, where he was on staff full-time from 1994-2015.  Dr. Parikh is the author / editor of two books and over 150 peer-reviewed articles and book chapters, and co-author of CANMAT treatment guidelines for Depression and for Bipolar Disorder, the world’s most cited mood disorder guidelines. He holds research grants from multiple funding agencies, covering studies in clinical treatments in mood disorders, health services research, genetics, epidemiology, and educational research. He has conducted clinical trials looking at the combination of medication and psychotherapy for bipolar disorder and for depression, as well as pharmacotherapy trials in mood disorders. Current major projects include a multi-site study of Biomarkers in Major Depression, Anti-Stigma interventions in Bipolar disorder, Workplace Depression interventions, and a RCT of Telephone-Delivered CBT for Bariatric Surgery patients. As medical director of Mensante, he helped create a novel internet system for recognition and management of mental disorders that is commercially marketed. Dr. Parikh serves as Secretary of the International Society for Affective Disorders, and Co-Head, Section of Affective Disorders, World Psychiatric Association; Medical Director, National Network of Depression Centers; and Education Chair, CANMAT (Canadian Network for Mood and Anxiety Treatments).  He is the recipient of multiple awards for research, teaching, and service.",
  },
  {
    key: "DrElliott",
    name: "Dr. Elliott Halparin",
    accreditations: "",
    photo: "doctors/doctor2.svg",
    bio: "Dr. Elliot Halparin is currently the President of the Board of the Halton Hills Family Health Team in Georgetown, Ontario. Dr. Halparin served as President of the Ontario College of Family Physicians (1987-1988) and the Ontario Medical Association (2002-2003). He graduated from the University of Manitoba in 1974, completed his family medicine residency training at the University of Toronto and practices comprehensive family medicine with the Halton Hills Family Health Team. Over the past thirty years, Dr. Halparin has chaired or participated on numerous committees related to issues concerning the delivery of health care both in the Province of Ontario and nationally. He played a role in developing the physician contract for Ontario's Family Health Networks and for several years acted as an advisor to the Ministry of Health and Long-Term Care during the implementation of Family Health Teams and the creation of a variety of new alternate funding arrangements. Dr. Halparin has also served on the Boards of Georgetown Hospital, Ontario College of Family Physicians, Ontario Medical Association, Canadian Medical Association, the College of Family Physicians of Canada and the Mississauga Halton LHIN. He is currently a councillor for the Canadian Medical Protective Association.",
  },
  {
    key: "DrNeil",
    name: "Dr. Neil A.",
    accreditations: "Ph.D., C.Psych.",
    photo: "doctors/doctor3.svg",
    bio: "Dr. Neil Rector is a Registered Clinical Psychologist and the Founder and Director of the Forest Hill Centre for CBT. His clinical approach combines up-to-date, scientifically supported cognitive-behavioural treatments for a range of client difficulties in a respectful, supportive, and collaborative environment. His areas of clinical expertise include helping people to overcome depression, anxiety, phobias, OCD and Related Disorders, and stress-related problems and to enhance and promote psychological well-being. He has a special interest in helping clients that experience co-occurring anxiety and depression as well as clients who have tried other treatments but achieved less than optimal outcomes. Dr. Rector completed a Ph.D. in clinical psychology at the University of York in England and the British Psychological Society’s Diploma/Doctorate in Clinical Psychology (Dip.Clin.Psych.) in 1996. He was a Lecturer at the Institute of Psychiatry, University of London and Psychologist at the Maudsley Hospital for the year 1995-1996 and then returned to the Clarke Institute of Psychiatry and the University of Toronto to complete post-doctoral fellowship training in the practice and research of cognitive behavioural therapy. Subsequently, he went on to receive advanced clinical training in CBT from the Beck Institute of Cognitive Therapy and Research (USA) and certification in CBT by the Academy of Cognitive Therapy. He was staff psychologist and Director of the Anxiety Disorders Clinic at the Centre for Addiction and Mental Health (CAMH) between 1998-2008 and Director of Clinical Practicum Training at CAMH between 1999-2005. Dr. Rector is now a Senior Research Scientist at the Sunnybrook Research Institute, Director of the Mood and Anxiety Treatment and Research Program, and Director of Research for the Frederick W. Thompson Anxiety Disorders Centre at Sunnybrook Health Sciences Centre. He remains affiliated with the University of Toronto as a Full Professor in the Departments of Psychiatry and Psychological Clinical Science",
  },
  {
    key: "DrBrenda",
    name: "Dr. Brenda B. Toner",
    accreditations: "Ph.D., C.Psych.",
    photo: "doctors/doctor4.svg",
    bio: "Dr. Brenda B. Toner, PhD, C. Psych., is Full Professor in the Department of Psychiatry and Graduate Coordinator, Institute of Medical Science, Faculty of Medicine, University of Toronto. For the past 30 years, Dr. Toner has been involved in mental health and well-being. She has held many leadership positions including Head of the Women’s Mental Health Program and the Director of the Fellowship Program in the Department of Psychiatry at the University of Toronto.  Through this work she became increasingly more interested in the study and practice of mindfulness.  She has published over 100 articles/book chapters and has given over 200 presentations on a variety of topics including eating disorders, anxiety, depression, irritable bowel syndrome and mindfulness. She currently teaches a Psychology of Mindfulness course in the Psychology Department and leads a weekly Mindful Meditation class through Health and Wellness at the University of Toronto.",
  },
  {
    key: "DrMark",
    name: "Dr. Mark H. Pollack",
    accreditations: "M.D., Ph.D.",
    photo: "doctors/doctor5.svg",
    bio: "Dr. Pollack is Director of the Center for Anxiety and Traumatic Stress Disorders at the Massachusetts General Hospital, and Professor of Psychiatry at Harvard Medical School. He has published over 300 articles, reviews and book chapters. He serves on the Scientific Advisory Board of the Anxiety Disorders Association of America, and the Mood and Anxiety Disorders Institute of the Massachusetts General Hospital, as well as other advisory and editorial boards. His areas of clinical and research interest include the acute and longterm course, pathophysiology and treatment of patients with anxiety disorders including panic disorder, social anxiety disorder, PTSD and generalized anxiety disorder and associated comorbidities, development of novel pharmacologic agents for mood and anxiety disorders, uses of combined cognitive-behavioral and pharmacologic therapies for treatment refractory patients, presentation and treatment of anxiety in the medical setting, and the pathophysiology and treatment of substance abuse.",
  },
  {
    key: "DrTim",
    name: "Dr. Tim Bilkey",
    accreditations: "MD, FRCP(C)",
    photo: "doctors/doctor6.svg",
    bio: "Dr. Bilkey is a psychiatrist specializing in ADHD in adolescents and adults. He is Adjunct Professor, Department of Psychiatry, Schulich School of Medicine and Dentistry, The University of Western Ontario and serves as Adjunct Mentor for the Ontario College of Family Physicians Collaborative Mental Health Project. He was the 2008 Content Chair for the CPA Collaborative Forums in Mental Health. Dr. Bilkey has completed a medical documentary on ADHD and has developed an educational program for primary care physicians accredited through the College of Family Physicians of Canada.",
  },
  {
    key: "DrSidney",
    name: "Dr. Sidney Kennedy",
    accreditations: "M.Sc, MD, Ph.D., FRCP(C)",
    photo: "doctors/doctor7.svg",
    bio: "Dr. Kennedy is a professor of psychiatry at the University of Toronto, Psychiatrist-in-Chief of the University Health Network, Toronto, President of the Canadian College of Neuropsycho-pharmacology, and a founding member and executive chair of the Canadian Network for Mood and Anxiety Treatments (CANMAT), the policy setting body of Canadian Psychiatry. He has authored and co-authored over 175 peer-reviewed articles, written nine books, and contributed over 40 separate chapters in various medical books and textbooks. He sits on many domestic and international psychiatric boards and has received several prestigious awards.",
  },
  {
    key: "DrWilliam",
    name: "Dr. William Gnam M.Sc.",
    accreditations: "M.Sc, MD, Ph.D., FRCP(C)",
    photo: "doctors/doctor8.svg",
    bio: "Dr. Gnam is a psychiatrist and a Harvard-trained health economist. He is currently a Research Associate at the Institute for Work and Health in Toronto where he specializes in the economics of mental disorders, analyzing the costs of health care delivery, worker productivity losses and associated societal costs. He has published over 11 articles and is a Rhodes Scholar.",
  },
  {
    key: "DrZindel",
    name: "Zindel V. Segal",
    accreditations: "M.A., Ph.D.",
    photo: "doctors/doctor9.svg",
    bio: "Zindel Segal, PhD, is Distinguished Professor of Psychology in Mood Disorders at the University of Toronto – Scarborough and a Senior Scientist in the Campbell Family Mental Health Research Institute at the Centre for Addiction and Mental Health.  Dr. Segal has pioneered the use of mindfulness meditation for promoting wellness in the area of mood disorders.  An author of over 10 books and 130 scientific publications, including The Mindful Way Through Depression – a patient guide for achieving mood balance in everyday life. ",
  },
  {
    key: "DrRichard",
    name: "Dr. Richard Swinson",
    accreditations: "B.A., M.D., FRCP(C), FRC Psych, DPM",
    photo: "doctors/doctor10.jpg",
    bio: "Dr. Swinson is currently the Medical Director of the Anxiety Treatment and Research Centre, St. Joseph’s Healthcare Hamilton and Professor Emeritus in the Department of Psychiatry and Behavioural Neurosciences, McMaster University, Hamilton, Ontario. His clinical practice is focused upon anxiety and related disorders with an emphasis on OCD and related disorders. He has published approximately 200 peer reviewed papers, 10 books, and 40 chapters mainly on the subjects of anxiety disorders and substance dependence. His current research activity is funded by Canadian Fund for Innovation, Ontario Research Development Fund and Canadian Institutes of Health Research and Advanced Neuromodulation Services, Texas. He is the lead author on the Canadian Anxiety Disorders Guidelines (2006).",
  },
]
const lngs = {
  en: { nativeName: "En" },
  fr: { nativeName: "Fr" },
}
class AboutUs extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    company: "",
    position: "",
    interest: "",
    message: "",
    loading: false,
    error: "",
    success: "",
    showItems: 5,
    isContactValid: true,
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    const { name, email, phone, company, position, interest, message } =
      this.state
    if (
      !name ||
      !email ||
      !phone ||
      !company ||
      !position ||
      !interest ||
      !message
    ) {
      return this.setState({ error: "All fields are required.", success: "" })
    }
    this.setState({ error: "", success: "" })

    if (!this.validateEmail(email)) {
      return this.setState({ error: "Please Enter a valid email address." })
    }
    if (!isValidPhoneNumber(phone)) {
      return this.setState({ isContactValid: false })
    }
    this.setState({ isContactValid: true })

    this.setState({ loading: true, error: "", success: "" })
    try {
      const response = await axios.post(`${baseUrl}/email/contact`, {
        name,
        email,
        phone,
        company,
        position,
        interest,
        message,
      })
      this.setState({
        success: response?.data?.message || "Message sent",
        loading: false,
        name: "",
        email: "",
        phone: "",
        company: "",
        position: "",
        interest: "",
        message: "",
        error: "",
      })
    } catch (error) {
      console.error(error)
      this.setState({
        error: error?.response?.data?.message || error.message,
        loading: false,
        success: "",
      })
    }
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  setPhone = (e) => {
    this.setState({ phone: e })
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.handleWindowResize.bind(this))
    }
  }

  componentDidMount() {
    if (window) {
      window.addEventListener("resize", this.handleWindowResize.bind(this))
      this.handleWindowResize()
    }
    this.props.i18n.changeLanguage(store.get("lang") || "en")
  }

  handleWindowResize = () => {
    if (window) {
      let showItems = 5
      let naturalSlideHeight = 150
      if (window.innerWidth < 760) {
        showItems = 1
        naturalSlideHeight = 80
      } else if (window.innerWidth < 800) {
        showItems = 2
      } else if (window.innerWidth < 1050) {
        showItems = 3
      } else if (window.innerWidth < 1440) {
        showItems = 4
      } else if (window.innerWidth < 1980) {
        showItems = 4
      }
      this.setState({
        showItems,
        naturalSlideHeight,
      })
    }
  }
  setIsOpen = (val) => {
    this.setState({
      isPaneOpen: val,
    })
  }

  render() {
    const { t, i18n } = this.props
    const props = this.props
    const { showItems, naturalSlideHeight } = this.state
    const { isContactValid } = this.state
    const { isPaneOpen } = this.state

    return (
      <ErrorBoundary FallbackComponent={ErrorScreen}>
        <div>
          <div className="about-top">
            <div className="container">
              {/*
            <div className="gradient"></div>
            */}
              {/* <img
            id="page-1"
            className="mountain_image"
            src={require("../../assets/images/banner2.png")}
            alt=""
            style={{ width: "100%" }}
            /> */}
              <Header />
              <div className="fbnIntro fbnIntro-about">
                <div className="about-full wow fadeInUp">
                  <div className="about-left">
                    <h4 className=" introHeadline">
                      {t("aboutUsPage.introSection.headline")}
                    </h4>
                    <h2 className="about-us-content-header">
                      {t("aboutUsPage.introSection.subHeadline")}{" "}
                    </h2>
                    <p className="aboutus-content-p">
                      {t("aboutUsPage.introSection.description1")}
                    </p>
                  </div>
                  <div className="about-right">
                    {(store.get('lang') || 'en') === 'en' ?
                      <iframe
                        id="fbnVideo"
                        name="video"
                        title="homePageVideo"
                        src="https://player.vimeo.com/video/495541623"
                        width="550"
                        height="368"
                        // frameborder="0"
                        allow="autoplay; fullscreen"
                      // allowfullscreen 
                      />
                      :
                      <iframe
                        id="fbnVideo"
                        name="video"
                        title="homePageVideo"
                        src="https://player.vimeo.com/video/495541623"
                        width="550"
                        height="368"
                        // frameborder="0"
                        allow="autoplay; fullscreen"
                      // allowfullscreen 
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="feeling-about-section wow fadeInUp">
            <div className="container">
              <h4>{t("aboutUsPage.about.aboutUS")}</h4>
              <h2>{t("aboutUsPage.about.heading")}</h2>
              <p>{t("aboutUsPage.about.content1")}</p>
              <p>{t("aboutUsPage.about.content2")}</p>
              <p>{t("aboutUsPage.about.content3")}</p>
            </div>
          </div>
          <div className="timeline-content timeline-image" id="timeline">
            <div className="container">
              <h4>{t("aboutUsPage.history.title")}</h4>
              <h2>{t("aboutUsPage.history.heading")}</h2>
              <div className="timeline">
                <div className="timeline-container left wow fadeInUp">
                  <div className="content">
                    <div className="date">2005</div>
                    <p>{t("aboutUsPage.history.year2005")}</p>
                  </div>
                </div>
                <div className="timeline-container right wow fadeInUp">
                  <div className="content">
                    <div className="date">2006</div>
                    <p>{t("aboutUsPage.history.year2006")}</p>
                  </div>
                </div>
                <div className="timeline-container left wow fadeInUp">
                  <div className="content">
                    <div className="date">2008</div>
                    <p>{t("aboutUsPage.history.year20081")}</p>
                    <p>{t("aboutUsPage.history.year20082")}</p>
                  </div>
                </div>
                <div className="timeline-container right wow fadeInUp">
                  <div className="content">
                    <div className="date">2010</div>
                    <p>{t("aboutUsPage.history.year2010")}</p>
                  </div>
                </div>
                <div className="timeline-container left wow fadeInUp">
                  <div className="content">
                    <div className="date">2011</div>
                    <p>{t("aboutUsPage.history.year2011")}</p>
                  </div>
                </div>
                <div className="timeline-container right wow fadeInUp">
                  <div className="content">
                    <div className="date">2013</div>
                    <p>{t("aboutUsPage.history.year2013")}</p>
                    <p>{t("aboutUsPage.history.year20132")}</p>
                  </div>
                </div>
                <div className="timeline-container left wow fadeInUp">
                  <div className="content">
                    <div className="date">2014</div>
                    <p>{t("aboutUsPage.history.year2014")}</p>
                  </div>
                </div>
                <div className="timeline-container right wow fadeInUp">
                  <div className="content">
                    <div className="date">2015</div>
                    <p>{t("aboutUsPage.history.year2015")}</p>
                  </div>
                </div>
                <div className="timeline-container left wow fadeInUp">
                  <div className="content">
                    <div className="date">2016</div>
                    <p>{t("aboutUsPage.history.year2016")}</p>
                  </div>
                </div>
                <div className="timeline-container right wow fadeInUp">
                  <div className="content">
                    <div className="date">2018</div>
                    <p>{t("aboutUsPage.history.year2018")}</p>
                  </div>
                </div>
                <div className="timeline-container left wow fadeInUp">
                  <div className="content">
                    <div className="date">2020</div>
                    <p>{t("aboutUsPage.history.year2020")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="user-result-wrpper" id="user-result">
            <div className="container">
              <h4>{t("aboutUsPage.userResult.smalltitle")}</h4>
              <h2>{t("aboutUsPage.userResult.maintitle")}</h2>
              <div className="full">
                <div className="left">
                  <img
                    src={require("../../assets/images/user_result_img.png")}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="right">
                  <div className="accordion" id="accordionExample">
                    <div className="card">
                      <div className="card-head" id="headingOne">
                        <h2
                          className="mb-0"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          {t("aboutUsPage.userResult.point3.title")}
                        </h2>
                      </div>
                      <div
                        id="collapseOne"
                        className="collapse show"
                        aria-labelledby="headingOne"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body">
                          <ul>
                            <li>
                              {t("aboutUsPage.userResult.point1.description1")}
                            </li>
                            <li>
                              {t("aboutUsPage.userResult.point1.description2")}
                            </li>
                            <li>
                              {t("aboutUsPage.userResult.point1.description3")}
                            </li>
                            <li>
                              {t("aboutUsPage.userResult.point1.description4")}
                            </li>
                            <li>
                              {t("aboutUsPage.userResult.point1.description5")}
                            </li>
                            <li>
                              {t("aboutUsPage.userResult.point1.description6")}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-head" id="headingTwo">
                        <h2
                          className="mb-0 collapsed"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {t("aboutUsPage.userResult.point2.title")}
                        </h2>
                      </div>
                      <div
                        id="collapseTwo"
                        className="collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body">
                          <ul>
                            <li>
                              {t("aboutUsPage.userResult.point2.description1")}
                            </li>
                            <li>
                              {t("aboutUsPage.userResult.point2.description2")}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-head" id="headingThree">
                        <h2
                          className="mb-0 collapsed"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          {t("aboutUsPage.userResult.point1.title")}
                        </h2>
                      </div>
                      <div
                        id="collapseThree"
                        className="collapse"
                        aria-labelledby="headingThree"
                        data-parent="#accordionExample"
                      >
                        <div className="card-body">
                          <ul>
                            <li>
                              {t("aboutUsPage.userResult.point3.description1")}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="board wow fadeInUp" id="advisoryBoard">
            <div className="container">
              <h4 className="board_title" id="page-3">
                {t("aboutUsPage.boardsSection.headline")}
              </h4>
              {console.log("window.innerWidth", showItems)}
              <div className="">
                <div className="">
                  <CarouselProvider
                    naturalSlideWidth={100}
                    naturalSlideHeight={50}
                    totalSlides={doctors.length}
                    visibleSlides={showItems}
                  >
                    <Slider>
                      {doctors.map((doctor, index) => (
                        <Slide index={index}>
                          <div className="team-wrapper">
                            <div className="img-block">
                              <img
                                height="259px"
                                src={require(`../../assets/images/${doctor.photo}`)}
                                alt=""
                              />
                            </div>
                            <div className="team-data">
                              <p className="">{doctor.name}</p>
                              <button
                                className=""
                                data-toggle="modal"
                                data-target={`#doctor${index}`}
                                type="button"
                              >
                                <h6 className="">
                                  {t("aboutUsPage.boardsSection.bio")}
                                </h6>
                              </button>
                            </div>
                          </div>
                        </Slide>
                      ))}
                    </Slider>
                    <ButtonBack className="left-rounded-arrow left-rounded-arrow_left" />
                    <ButtonNext className="left-rounded-arrow left-rounded-arrow_right" />
                  </CarouselProvider>
                  {doctors.map((doctor, index) => {
                    const accreditationsKey = `aboutUsPage.doctors.${doctor.key}.accreditations`
                    console.log("accreditationsKey", accreditationsKey)
                    const bioKey = `aboutUsPage.doctors.${doctor.key}.bio`
                    return (
                      <ClinicalAdvisoryCard
                        name={doctor.name}
                        bio={t(bioKey)}
                        imgSource={doctor.photo}
                        accreditations={t(accreditationsKey)}
                        id={index}
                      />
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="information wow fadeInUp">
            <div className="container">
              <h4>{t("aboutUsPage.awardWinning.title")}</h4>
              <h2>{t("aboutUsPage.awardWinning.heading")}</h2>
              <div className="award-blovk-full">
                <div className="award-blovk-left">
                  <img
                    className="vector"
                    src={require("../../assets/images/award-img.png")}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="award-blovk-right">
                  <p>{t("aboutUsPage.awardWinning.data1")}</p>
                  <p>{t("aboutUsPage.awardWinning.data2")}</p>
                  <p>{t("aboutUsPage.awardWinning.data3")}</p>
                  <ul>
                    <li>{t("aboutUsPage.awardWinning.title1")}</li>
                    <li>{t("aboutUsPage.awardWinning.title2")}</li>
                    <li>{t("aboutUsPage.awardWinning.title3")}</li>
                  </ul>
                </div>
              </div>
              {/*
            <div className="information-container">
               <div className="container">
                  <div className="row">
                     <div className="col">
                        <h4 className="info-title">Award-winning and</h4>
                        <h4 className="info-title">internationally recognized</h4>
                        <p className="info-text">
                           In 2005, the College of Family Physicians of Canada reviewed
                           and approved FeelingBetterNow® as a practice management tool
                           available to assist physicians in patient care. <br></br>
                           <br></br>In 2008, Dr. Ozersky received the Physician
                           Innovation Award from COACH, Canada’s Health Informatics
                           Association.
                           <br></br>
                           <br></br> FBN’s success is measured by our coverage of over 1
                           million Canadians and its 90% renewal rate of customers
                           including insurers, employers, member associations, hospitals,
                           colleges and universities.<br></br>
                           <br></br>
                        </p>
                        <div className="two">
                           <p>
                              <img
                              className="icon-checkmark"
                              src={require("../assets/images/icon-checkmark.svg")}
                              alt=""
                              style={{ width: "100%" }}
                              />
                           </p>
                           <p className="info-text awards-list">
                              Confidential and anonymous
                           </p>
                        </div>
                        <div className="two">
                           <p>
                              <img
                              className="icon-checkmark"
                              src={require("../assets/images/icon-checkmark.svg")}
                              alt=""
                              style={{ width: "100%" }}
                              />
                           </p>
                           <p className="info-text awards-list">
                              Trusted by care providers
                           </p>
                        </div>
                        <div className="two">
                           <p>
                              <img
                              className="icon-checkmark"
                              src={require("../assets/images/icon-checkmark.svg")}
                              alt=""
                              style={{ width: "100%" }}
                              />
                           </p>
                           <p className="info-text awards-list">
                              Award winning innovation
                           </p>
                        </div>
                     </div>
                     <div className="col">
                        <img
                        className="vector"
                        src={require("../assets/images/award-winning.png")}
                        style={{ width: "100%" }}
                        />
                     </div>
                  </div>
               </div>
            </div>
            */}
              {/* <img
            className="vector"
            src={require("../../assets/images/award-winning-div.png")}
            style={{ width: "100%" }}
            /> */}
            </div>
          </div>
          <div className="demo wow fadeInUp" id="contact">
            <div className="container demo-container">
              <div className="demo-row">
                <div className="col-left" id="border-line">
                  <h4>{t("aboutUsPage.contactUs.headline")}</h4>
                  <h2 className="demo-title">
                    {t("aboutUsPage.demoSection.headline")}
                  </h2>
                  <p className="demo-description">
                    {t("aboutUsPage.demoSection.description1")}
                  </p>
                  <p className="demo-description">
                    {t("aboutUsPage.demoSection.description2")}
                  </p>
                  <p className="contact-info mail-cnt" id="mail-contact">
                    <a href="mailto:sales@mensante.com">
                      {" "}
                      <img
                        className="contact-icon"
                        src={require("../../assets/images/icon-email.svg").default}
                        alt=""
                      />
                      sales@mensante.com
                    </a>{" "}
                  </p>
                  <p className="contact-info last">
                    <a href="tel:416-928-9195">
                      <img
                        className="contact-icon"
                        src={require("../../assets/images/telephone-icon.svg").default}
                        alt=""
                      />
                      416-928-9195
                    </a>
                  </p>
                </div>
                <div className="col-right">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-box">
                      <div className="two-field">
                        <div className="input-field">
                          <label>
                            {t("aboutUsPage.formSection.nameLabel")} <em>*</em>
                          </label>
                          <input
                            type="text"
                            className="form-control demo-input resize"
                            id="exampleInputName"
                            aria-describedby="nameHelp"
                            placeholder={t("aboutUsPage.formSection.name")}
                            required
                            maxLength={50}
                            value={this.state.name}
                            onChange={this.handleChange}
                            name="name"
                            disabled={this.state.loading}
                          />
                        </div>
                        <div className="input-field">
                          <label>
                            {t("aboutUsPage.formSection.companyLabel")}{" "}
                            <em>*</em>
                          </label>
                          <input
                            type="company"
                            className="form-control demo-input resize"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder={t("aboutUsPage.formSection.company")}
                            required
                            maxLength={50}
                            name="company"
                            value={this.state.company}
                            disabled={this.state.loading}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="two-field">
                        <div className="input-field">
                          <label>
                            {t("aboutUsPage.formSection.emailLabel")} <em>*</em>
                          </label>
                          <input
                            type="email"
                            className="form-control demo-input resize"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder={t("aboutUsPage.formSection.email")}
                            required
                            maxLength={350}
                            name="email"
                            value={this.state.email}
                            disabled={this.state.loading}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="input-field">
                          <label>
                            {t("aboutUsPage.formSection.phoneLabel")} <em>*</em>
                          </label>
                          <Input
                            type={"tel"}
                            placeholder={t("aboutUsPage.formSection.phone")}
                            country="US"
                            value={this.state.phone}
                            maxLength={14}
                            onChange={(e) => this.setPhone(e)}
                            className="form-control demo-input resize"
                            disabled={this.state.loading}
                          />
                        </div>
                      </div>
                      <div className="two-field">
                        <div className="input-field">
                          <label>
                            {t("aboutUsPage.formSection.positionLabel")}{" "}
                            <em>*</em>
                          </label>
                          <input
                            type="position"
                            className="form-control demo-input resize"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder={t("aboutUsPage.formSection.position")}
                            name="position"
                            maxLength={50}
                            value={this.state.position}
                            disabled={this.state.loading}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="input-field">
                          <label>
                            {t("aboutUsPage.formSection.interestedLabel")}
                          </label>
                          <select
                            disabled={this.state.loading}
                            className="form-select demo-input demo-input-multi-select resize form-control"
                            name="interest"
                            onChange={this.handleChange}
                            value={this.state.interest}
                          >
                            <option value="" disabled selected>
                              {t("aboutUsPage.formSection.interested")}
                            </option>
                            <option value="Scheduling a demo">
                              {t("aboutUsPage.formSection.option1")}
                            </option>
                            <option value="Receiving an Information Package">
                              {t("aboutUsPage.formSection.option2")}
                            </option>
                            <option value="Joining Email List">
                              {t("aboutUsPage.formSection.option3")}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="input-field">
                        <label>
                          {t("aboutUsPage.formSection.messageLabel")}
                        </label>
                        <textarea
                          type="message"
                          className="form-control demo-input demo-input-message"
                          id="exampleInputPassword1"
                          placeholder={t("aboutUsPage.formSection.message")}
                          name="message"
                          maxLength={100}
                          value={this.state.message}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="about-submit-btn">
                        <button
                          type="submit"
                          className="btn submit-btn"
                          disabled={this.state.loading}
                        >
                          {t("aboutUsPage.formSection.submit")}
                        </button>
                        <p></p>
                      </div>
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          margin: "16px",
                        }}
                      >
                        {this.state.error}
                      </p>
                      {isContactValid === false ? (
                        <p
                          style={{
                            color: "red",
                            textAlign: "left",
                            margin: "16px",
                          }}
                        >
                          {t("profile.validContact")}
                        </p>
                      ) : (
                        <p />
                      )}
                      <p
                        style={{
                          color: "green",
                          textAlign: "left",
                          margin: "16px",
                        }}
                      >
                        {this.state.success}
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <Footer />
          </div>
          {/* <div className="downButtons">
         {Object.keys(lngs).map((lng) => (
         <button
         key={lng}
         className="lngBtn"
         style={{
         fontWeight: i18n.language === lng ? "bold" : "normal",
         outline: 0,
         }}
         type="submit"
         onClick={() => i18n.changeLanguage(lng)}
         >
         {lngs[lng].nativeName}
         </button>
         ))}
      </div> */}
          {/* <div>
         <ReactSlidingSidePanel />
      </div> */}
        </div>
      </ErrorBoundary>
    )
  }
}
export default withTranslation()(AboutUs)
